import { render, staticRenderFns } from "./Users_list.vue?vue&type=template&id=71040703&scoped=true&"
import script from "./Users_list.vue?vue&type=script&lang=js&"
export * from "./Users_list.vue?vue&type=script&lang=js&"
import style0 from "./Users_list.vue?vue&type=style&index=0&id=71040703&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71040703",
  null
  
)

export default component.exports